<template src='./effects.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import FormSetup from '@/components/misc/form-setup/FormSetup'

export default {
  components: {
    'form-setup': FormSetup
  },
  data () {
    return {
      help: {
        form: Vue.$helpConfig.projectFormEffects
      },
      formMarkdownElements: [
        {
          editor: 'root.basic.problem',
          element: 'root[basic][problem]',
          name: 'basic.problem'
        },
        {
          editor: 'root.basic.goals',
          element: 'root[basic][goals]',
          name: 'basic.goals'
        },
        {
          editor: 'root.basic.activities',
          element: 'root[basic][activities]',
          name: 'basic.activities'
        },
        {
          editor: 'root.effect.relevance',
          element: 'root[effect][relevance]',
          name: 'effect.relevance'
        },
        {
          editor: 'root.effect.eficiency',
          element: 'root[effect][eficiency]',
          name: 'effect.eficiency'
        },
        {
          editor: 'root.effect.sustainability',
          element: 'root[effect][sustainability]',
          name: 'effect.sustainability'
        },
        {
          editor: 'root.effect.summary',
          element: 'root[effect][summary]',
          name: 'effect.summary'
        },
        {
          editor: 'root.notes',
          element: 'root[notes]',
          name: 'notes'
        }
      ]
    }
  },
  methods: {
    setupPage () {
      if (this.$refs.setup) {
        this.$refs.setup.loading = true
      }
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId)
        .then(
          response => {
            this.logConsole(response)
            const form = response.data.payload
            this.$refs.setup.formName = form.name
            this.$refs.setup.project = response.data.additionalInformation
            this.$refs.setup.formStatus = form.status
            this.$refs.setup.formCode = form.code
            this.$refs.setup.formatRevisions(form.inputJsonRevisions, 'efekti')
            this.$refs.setup.pif = JSON.parse(form.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.initializeEditor()
            this.$refs.setup.initialVal = form.inputJson === '{}' ? this.$refs.setup.editor.getValue() : JSON.parse(form.inputJson)
            this.$refs.setup.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    changeRevision (selectedRevision) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId + '/revision/' + selectedRevision)
        .then(
          response => {
            this.logConsole(response)
            const revision = response.data.payload
            this.$refs.setup.pif = JSON.parse(revision.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.$refs.setup.initialVal = revision.inputJson ? JSON.parse(revision.inputJson) : null
            this.initializeEditor()
            history.pushState({}, null, ('/projects/' + this.$refs.setup.projectCode + '/phases/' + Number(this.$refs.setup.projectPhaseId) + '/forms/efekti/id/' + Number(this.$refs.setup.phaseFormId) + '/revision/' + this.$refs.setup.revision.revision))
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    initializeEditor () {
      this.$refs.setup.configureEditor()
      this.$refs.setup.editor.on('ready', () => {
        this.initialMarkdownControls()
        if (this.$refs.setup.initialVal) {
          this.$refs.setup.saveJsonValues(this.$refs.setup.initialVal)
        }
        this.$refs.setup.manageInput()
      })

      this.$refs.setup.editor.on('change', () => {
        this.checkChanges()
      })
      console.log(this.$refs.setup.editor)
    },
    checkChanges () {
      const values = this.$refs.setup.editor.getValue()
      for (var i = 0; i < this.$refs.setup.markdownElements.length; i++) {
        const elem = this.$refs.setup.markdownElements[i].name
        const value = this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[i].editor) ? this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[i].editor).simplemde_instance.value() : ''
        const chars = elem.split('.')
        if (chars.length === 2) {
          values[chars[0]][chars[1]] = value
        } else {
          values[chars[0]] = value
        }
      }
      const val = this.$refs.setup.initialVal
      delete val['basic.problem']
      delete val['basic.goals']
      delete val['basic.activities']
      delete val['effect.relevance']
      delete val['effect.eficiency']
      delete val['effect.sustainability']
      delete val['effect.summary']
      this.$refs.setup.formChanged = !this.deepEqual(val, values)
    },
    initialMarkdownControls () {
      for (var j = 0; j < this.$refs.setup.markdownElements.length; j++) {
        this.$refs.setup.configureMarkdownElement(this.$refs.setup.markdownElements[j])
        if (this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor)) {
          this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor).simplemde_instance.codemirror.on('change', () => {
            this.checkChanges()
          })
        }
      }
    }
  },
  created () {
    this.setupPage()
    EventBus.$on('setupPage', () => {
      if (this.$refs && this.$refs.setup) {
        this.$refs.setup.revision = {
          revision: null
        }
      }
      this.setupPage()
    })
    EventBus.$on('changeRevision', (revision) => {
      this.changeRevision(revision)
    })
  },
  beforeDestroy () {
    EventBus.$off('setupPage')
    EventBus.$off('changeRevision')
  }
}
</script>
